import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import Breadcrumbs from "../../reusebale/breadcrumbs";
import TransactionsList from "./transactionsList";

const TransactionsTable = ({ onBack, leaseId }) => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [leaseDetails, setLeaseDetails] = useState(null);
  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    totalPages: 0,
    limit: 10,
  });

  const itemsPerPage = 10;

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1; // Convert 0-indexed to 1-indexed
    fetchTransactions(newPage);
  };

  const fetchTransactions = async (page = 1) => {
    if (!leaseId) return;
    
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      // Fetch transactions with pagination
      const transactionsResponse = await fetch(
        `${BaseUrl}api/payment-transaction/lease/${leaseId}?page=${page}&limit=${itemsPerPage}`,
        requestOptions
      );
      const transactionsResult = await transactionsResponse.json();

      if (transactionsResult.status === "success" && transactionsResult.data) {
        setTransactions(transactionsResult.data);
        if (transactionsResult.pagination) {
          setPagination(transactionsResult.pagination);
        }
      } else {
        setTransactions([]);
        setPagination({
          total: 0,
          currentPage: 1,
          totalPages: 0,
          limit: itemsPerPage,
        });
      }

      // Fetch lease details to get property info (only on first load)
      if (page === 1 && !leaseDetails) {
        const leaseResponse = await fetch(
          `${BaseUrl}api/lease/getLeaseDetails/${leaseId}`,
          requestOptions
        );
        const leaseResult = await leaseResponse.json();

        if (leaseResult.success) {
          setLeaseDetails(leaseResult.data);
        }
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setTransactions([]);
      setPagination({
        total: 0,
        currentPage: 1,
        totalPages: 0,
        limit: itemsPerPage,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions(1);
  }, [leaseId]);

  return (
    <div className="mt-5 w-full">
      <Breadcrumbs
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        subheading="Transactions"
        onBack={onBack}
        recordId={leaseId ? `LES-${leaseId?.slice(0, 10)}` : ""}
      />

      <div className="bg-white w-full rounded-lg mt-5">
        <div className="w-[95%] mx-auto h-full py-5">
          <TransactionsList
            transactions={transactions}
            loading={loading}
            leaseDetails={leaseDetails}
            limit={null}
            showHeaders={true}
            showExtendedColumns={true}
          />
          
          {pagination.totalPages > 1 && (
            <div className="mt-5">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination flex justify-center items-center gap-2"}
                pageClassName={"px-3 py-1 rounded border border-gray-300 cursor-pointer"}
                pageLinkClassName={"text-darkColor font-popinsMedium text-sm"}
                activeClassName={"bg-themeColor text-white border-themeColor"}
                previousClassName={"px-3 py-1 rounded border border-gray-300 cursor-pointer"}
                nextClassName={"px-3 py-1 rounded border border-gray-300 cursor-pointer"}
                disabledClassName={"opacity-50 cursor-not-allowed"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionsTable;

